<!-- 上传多附件 -->
<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" @close="close">
    <el-upload
      class="upload-demo"
      action
      multiple
      :limit="MAX_LIMIT"
      :on-remove="handleRemove"
      :before-upload="befUploadCheckFileSize"
      :http-request="submitUpload"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-button size="mini" type="primary">+添加附件</el-button>
      <div slot="tip" class="el-upload__tip">{{`限制选择${MAX_LIMIT}个文件，单个文件大小不能超过${FILE_SIZE_MB}MB`}}</div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="confirmLoading" @click="handleConfirm">{{ confirmLoading ? '上传中...' : '确 定' }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getControlParam } from '@/modules/transport/bms/api/common';

export default {
    name: 'UploadMultipleDialog',
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        title: {
            type: String,
            default: '上传附件'
        },
        // 文件大小限制
        fileSize: {
            type: Number
        },
        // 文件数量限制
        maxLimit: {
            type: Number
        }
    },
    data() {
        return {
            dialogVisible: false,
            fileList: [],
            uploadDataArr: [],
            controlParamSize: 0,
            confirmLoading: false
        };
    },
    computed: {
        // 文件大小限制 (KB)
        FILE_SIZE() {
            return this.fileSize || this.controlParamSize || 1024;
        },
        // 文件大小限制 (MB 显示用)
        FILE_SIZE_MB() {
            return (this.FILE_SIZE / 1024);
        },
        // 文件数量限制
        MAX_LIMIT() {
            return this.maxLimit || 10;
        }
    },
    watch: {
        value(newVal) { // 监听父组件传入的值
            this.dialogVisible = newVal;
        }
    },

    methods: {
        // 删除单个附件
        handleRemove(file, fileList) {
            this.fileList = fileList;
            let temp = null;
            this.uploadDataArr.forEach((item, index) => {
                if (file.name === item.file.name) {
                    temp = index;
                }
            });
            this.uploadDataArr.splice(temp, 1);
        },
        // 文件上传前校验
        befUploadCheckFileSize(file) {
            const isExceed = file.size / 1024 <= this.FILE_SIZE;
            if (!isExceed) {
                this.$message.warning(`上传文件大小不能超过 ${this.FILE_SIZE_MB}MB`);
                return false;
            }
            return true;
        },
        // 上传文件
        submitUpload(uploadData) {
            if (uploadData) {
                this.uploadDataArr.push(uploadData);
            }
        },
        // 文件数量超出限制
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.MAX_LIMIT} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // 确定上传
        handleConfirm() {
            if (this.uploadDataArr.length === 0) {
                this.$message.warning('请先选择要上传的文件');
                return;
            }
            this.$emit('uploadConfirm', this.uploadDataArr);
            this.close();
        },
        // 弹窗关闭
        close() {
            this.dialogVisible = false;
            this.$emit('input', false); // 触发 v-model 更新
            this.fileList = [];
            this.uploadDataArr = [];
            this.$emit('close'); // 可选：自定义关闭事件
        },
        getControlParamSize() {
            // 获取系统控制参数
            const formData = new FormData();
            formData.append('controlParam', 'BMS_UPLOAD_FILE_SIZE_CONTROL');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.controlParamSize = Number(res.data.value);
                }
            });
        }
    },
    mounted() {
        this.getControlParamSize();
    }
};
</script>

<style lang="scss" scoped></style>
